'use strict'

// import Vue from 'vue'
// import Api from '@/api/searchbot.js'

const state = {
  loading: true,
  error: null,
  searchbot: null,
  options: [],
  route: null
}

const actions = {
  fetch ({commit}, {vacancyId}) {
    commit('fetch')

    commit('fetchSuccess', {id: '1', vacancy: {id: vacancyId}}) // TODO: fixture
  },

  save ({commit, dispatch, rootGetters}, model) {
    if (!model.id) {
      throw new Error('Searchbot empty id')
    }

    commit('save')

    // Api.updateOne(data)

    if (!rootGetters['vacancy/one'].is_published) {
      commit('updateRoute', {
        name: 'vacancy-voicebot',
        params: {
          id: model.vacancy.id
        }
      })
    }
  },

  disable ({commit, state}, model) {
    commit('save')

    /*
    const data = {
      id: model.id,
      is_active: false
    }

    Api.updateOne(data)
     */

    commit('updateRoute', {
      name: 'vacancy-voicebot',
      params: {
        id: model.vacancy.id
      }
    })
  }
}

const mutations = {
  fetch (state) {
    state.searchbot = null
    state.loading = true
  },

  fetchSuccess (state, data) {
    state.searchbot = data
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  },

  save (state) {
    state.loading = true
  },

  saveSuccess (state, data) {
    state.searchbot = data
    state.loading = false
  },

  saveFailure (state, err) {
    state.loading = false
    state.error = err
    console.error(err)
  },

  updateRoute (state, data) {
    state.route = data
  }
}

const getters = {
  error (state, getters) {
    return state.error
  },

  loading (state, getters) {
    return state.loading
  },

  one (state, getters) {
    return state.searchbot || {}
  },

  route (state, getters) {
    return state.route
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
